import { useRecommendedAccommodations } from "@/features/accommodation/hooks/useRecommendedAccommodations";
import AccommodationCard from "@/features/accommodation/components/AccommodationCard";
import { Loader2, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { usePerformanceTracking } from "@/lib/performance-monitor";

const RecommendedAccommodations = () => {
  usePerformanceTracking('RecommendedAccommodations');

  const { data: accommodations, isLoading, error } = useRecommendedAccommodations();

  if (error) return null; // Hide section if error
  if (!isLoading && (!accommodations || accommodations.length === 0)) return null;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <span>🏠</span>
            <span>편안한 휴식</span>
          </div>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            추천 숙소
          </h3>
          <p className="text-lg text-gray-600">
            홀씨가 엄선한 최고의 숙소에서 편안한 휴식을 즐기세요
          </p>
        </div>

        {isLoading ? (
          <div className="text-center py-12">
            <div className="flex justify-center items-center">
              <Loader2 className="w-8 h-8 animate-spin text-[#F39800]" />
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
            {accommodations?.map((accommodation, index) => (
              <div key={accommodation.accommodation_id} className="w-full max-w-sm">
                <AccommodationCard
                  accommodation={accommodation}
                  index={index}
                />
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-12">
          <Link
            to="/stay"
            className="inline-flex items-center gap-2 bg-white hover:bg-gray-50 text-gray-800 px-8 py-3 rounded-lg font-semibold transition-colors border border-gray-200"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <MapPin className="w-4 h-4" />
            모든 숙소 둘러보기
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RecommendedAccommodations;
